import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Drawer, List as AList, Row, Col, Empty } from 'antd';

import { StyledTitle as Title } from '../../../fields/Title';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { TutorGroupStudentsListItem } from './TutorGroupStudentsListItem';
import { FormattedMessage } from 'react-intl';

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  margin: 10px 0;
`;

const StyledSubtitle = styled.span`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  color: #000000;
  margin-bottom: 15px;
`;

const StyledEmptyDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const TutorGroupStudentsListDrawer = ({
  tutorGroupStudents = [],
  currentClassStudents = [],
  onClose,
  visible,
  remove,
  push
}) => {
  const currentTutorGroupDiffStudents = useMemo(() => {
    let filteredStudents = [];

    currentClassStudents?.forEach((student) => {
      const foundStudent = tutorGroupStudents?.find(
        ({ id }) => id === student.id
      );

      if (foundStudent) {
        filteredStudents = [...filteredStudents];
      } else {
        filteredStudents = [...filteredStudents, student];
      }
    });

    return filteredStudents;
  }, [currentClassStudents, tutorGroupStudents]);

  const addStudentOnClick = useCallback(
    ({ event, student }) => {
      console.log('addStudentOnClick, event: ', event);
      event.preventDefault();
      event.stopPropagation();

      push(student);
    },
    [push]
  );

  const removeStudentOnClick = useCallback(
    ({ event, student, index }) => {
      console.log('removeStudentOnClick, event: ', event);
      console.log('removeStudentOnClick, student: ', student);

      event.preventDefault();
      event.stopPropagation();

      remove(index);
    },
    [remove]
  );

  return (
    <Drawer
      title='Students'
      placement='right'
      width={window.innerWidth > 600 ? 600 : window.innerWidth}
      onClose={onClose}
      visible={visible}
    >
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col style={{ width: '100%' }}>
          <Title level={5}><FormattedMessage id="tutor-group.students-drawer.currentGroupEnrollment"/></Title>
          <StyledSubtitle>
            <FormattedMessage
              id="tutor-group.students-drawer.totalStudentsAdded"
              values={{ total: `${tutorGroupStudents.length ?? 0}/25` }}
            />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={tutorGroupStudents}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span>
                        <FormattedMessage id="tutor-group.emptyState.noStudents"/>
                      </span>
                      <span>
                        <FormattedMessage id="tutor-group.emptyState.addStudents"/>
                      </span>
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(student, index) => (
              <TutorGroupStudentsListItem
                student={student}
                index={index}
                onClick={removeStudentOnClick}
                icon={<MinusOutlined width={10} />}
              />
            )}
          />
        </Col>
      </Row>
      <StyledDivider />
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col style={{ width: '100%' }}>
          <Title level={5}><FormattedMessage id="tutor-group.students-drawer.currentClassEnrollment"/></Title>
          <StyledSubtitle>
            <FormattedMessage
              id="tutor-group.students-drawer.totalStudents"
              values={{ total: `${currentTutorGroupDiffStudents.length ?? 0}` }}
            />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={currentTutorGroupDiffStudents}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span>
                        <FormattedMessage id="tutor-group.emptyState.noStudentsToAdd"/>
                      </span>
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(student, index) => (
              <TutorGroupStudentsListItem
                student={student}
                index={index}
                onClick={addStudentOnClick}
                icon={<PlusOutlined />}
              />
            )}
          />
        </Col>
      </Row>
    </Drawer>
  );
};
